import { memo } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import _startsWith from 'lodash/startsWith';
//Local files
import { Img } from 'components/Dialogs/FilePreview/FilePreview.styled';
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import { getRepresentation } from 'helpers';
import { representationVariants } from 'helpers/constants';
import { appSelectors } from 'features/app';

const FilePreview = () => {
  const { closeFilePreviewDialog } = useApp();
  const { open, file } = useCustomSelector(appSelectors.getFilePreviewDialogData);
  const isImage = _startsWith(file?.content_type, 'image/');

  return (
    <BaseDialog
      open={open}
      onClose={closeFilePreviewDialog}
      PaperProps={{ sx: { width: 'auto' } }}
      title={file?.filename}
    >
      <DialogContent sx={{ width: '100%', borderTop: '1px solid #F1F0FC'}}>
        {isImage && (
          <Img src={getRepresentation(file?.representations, representationVariants.MEDIUM) || file?.localUrl} alt={file?.filename} />
        )}
        {!isImage && (
          <Typography variant='title24' align='center' component={'p'} pt={3}>Preview unavailable</Typography>
        )}
      </DialogContent>
    </BaseDialog>
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FilePreview {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);